export default __webpack_public_path__ + "static/media/ic-ru.03b11ad8.svg";